<template>
  <v-autocomplete
    no-data-text="Danh sách trống"
    v-bind="this.$attrs"
    return-object
    item-text="name"
    item-value="id"
    :items="dishes"
    @change="onChange"
    v-on:input="$emit('input', $event)"
    clearable
    :loading="loading"
  ></v-autocomplete>
</template>

<script>
import { Dish } from '@/plugins/api'

export default {
  data: () => ({
    loading: false,
    dishes: []
  }),
  props: {
    filters: {
      type: Object,
      default: () => {}
    }
  },
  computed: {},
  methods: {
    async fetchAllDishes(query) {
      this.loading = true
      const params = {
        ...query,
        _limit: -1
      }
      this.dishes = await Dish.fetch(params)
      this.loading = false
    },
    onChange(data) {
      this.$emit('change', data)
    }
  },
  watch: {
    filters: {
      handler(filters) {
        this.fetchAllDishes(filters)
      },
      immediate: true
    }
  }
}
</script>
